import { ConfigManager } from './ConfigManager';
import { printLog } from './utils';

export const routeOrderDetails = (orderId: number) => {
  if (window.self !== window.top) {
    if (window.top) {
      ConfigManager.v4OrderDetailsHost.split(',').forEach((host) => {
        try {
          parent.postMessage(
            {
              message: 'navigateToOrderDetails',
              orderId: orderId,
            },
            {
              targetOrigin: host,
            },
          );
        } catch (e) {
          printLog(
            'There was an error posting message to parent -- this is expected',
            e,
          );
        }
      });
    }
    return false;
  }
  return true;
};

export const openLinkNewTab = (path: string) => {
  if (window.self !== window.top) {
    if (window.top) {
      ConfigManager.v4OrderDetailsHost.split(',').forEach((host) => {
        try {
          parent.postMessage(
            {
              message: 'openLinkInNewTab',
              path: path,
            },
            {
              targetOrigin: host,
            },
          );
        } catch (e) {
          printLog(
            'There was an error posting message to parent -- this is expected',
            e,
          );
        }
      });
    }

    return false;
  }

  window.open(path, '_blank');
  return true;
};

export const isNativeRoute = (path: string) => {
  if (window.self !== window.top) {
    if (window.top) {
      ConfigManager.v4OrderDetailsHost.split(',').forEach((host) => {
        parent.postMessage(
          {
            message: 'openLinkInNewTab',
            path: path,
          },
          {
            targetOrigin: host,
          },
        );
      });
    }
    return false;
  }
  return true;
};

export const routeOrderDetailsQuoteLegacy = (
  quoteCorrelationId: string,
  quoteId: string,
) => {
  if (window.self !== window.top) {
    if (window.top) {
      ConfigManager.v4OrderDetailsHost.split(',').forEach((host) => {
        try {
          parent.postMessage(
            {
              message: 'navigateToOrderDetails',
              quoteId: quoteId,
              directive: 'newOrderFromQuote',
            },
            {
              targetOrigin: host,
            },
          );
        } catch (e) {
          printLog(
            'There was an error posting message to parent -- this is expected',
            e,
          );
        }
      });
    }
    return false;
  }
  return true;
};

export const routeOrderDetailsQuote = (quoteId: number) => {
  if (window.self !== window.top) {
    if (window.top) {
      ConfigManager.v4OrderDetailsHost.split(',').forEach((host) => {
        try {
          parent.postMessage(
            {
              message: 'navigateToOrderDetails',
              directive: 'newOrderFromQuote',
              quoteId: quoteId,
            },
            {
              targetOrigin: host,
            },
          );
        } catch (e) {
          printLog(
            'There was an error posting message to parent -- this is expected',
            e,
          );
        }
      });
    }
    return false;
  }
  return true;
};

export const routeOrderDetailsCopyOrder = (copyOrderId: string) => {
  // eslint-disable-next-line no-alert
  if (window.self !== window.top) {
    if (window.top) {
      ConfigManager.v4OrderDetailsHost.split(',').forEach((host) => {
        // eslint-disable-next-line no-alert
        try {
          parent.postMessage(
            {
              message: 'navigateToOrderDetails',
              copyOrderId: copyOrderId,
            },
            {
              targetOrigin: host,
            },
          );
        } catch (e) {
          printLog(
            'There was an error posting message to parent -- this is expected',
            e,
          );
        }
      });
    }
    return false;
  }
  return true;
};

export const oldLoadTotalCountEvent = (count: number) => {
  if (window.self !== window.top) {
    if (window.top) {
      ConfigManager.v4OrderDetailsHost.split(',').forEach((host) => {
        try {
          parent.postMessage(
            {
              message: 'oldLoadTotalCount',
              count: count,
            },
            {
              targetOrigin: host,
            },
          );
        } catch (e) {
          printLog(
            'There was an error posting message to parent -- this is expected',
            e,
          );
        }
      });
    }
    return false;
  }
  return true;
};
